import React from 'react';
import { IExpense, IInvoice, IPayment, PaymentType, TransactionType
 } from '../../../@types';
import { recordManualPayment } from '../../../backend-services';
import { PAYMENT_PROVIDER_LIST } from '../../../constants';
import { Button, SearchInput } from '../../common';
import { DropdownComponent, InputComponent } from '../../core/Forms';
import RecordPaymentSuccess from './SuccessModal';

interface ManualRecordPaymentProps {
  entity: IInvoice | IExpense;
  onRecordEntity: (payment: IPayment) => void;
 
}

const ManualRecordPayment: React.FC<ManualRecordPaymentProps> = ({ entity, onRecordEntity, }) => {
 
  const [isLoading, setIsLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [amount, setAmount] = React.useState('');
  const [date, setDate] = React.useState('');
  const [method, setMethod] = React.useState< PaymentType>();
const [payment, setPayment] = React.useState<TransactionType>('revenue');
  const [error, setError] = React.useState<string>();
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('');

  const validateInput = (): boolean => {
    if (!amount || !selectedValue || !date) {
      setError('All fields are required.');
      return false;
    }
    setError(undefined);
    return true;
  };
  

  const handleRecordPayment = (e: any) => {
    e.preventDefault();
    console.log('handleRecordPayment called');
    if (!validateInput()) return;

    // const paymentType = method as string;
    setIsLoading(true);
    recordManualPayment({
      companyId: entity.companyId as string,
      entityId: entity.id,
      customerId: entity.customer.id,
      paymentType: selectedValue as string as PaymentType,
      paymentDate: date,
      amount: Number(amount),
      entityType: payment as TransactionType,
      outletId:entity.outletId as string,
    })
      .then((data) => {
        setIsLoading(false);
        setSuccess(true);
        setTimeout(() => {
          onRecordEntity(data);
        }, 2000);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  if (success) {
    return <RecordPaymentSuccess />;
  }

  const dropDownPaymentMethod = PAYMENT_PROVIDER_LIST;

  const handleChange = (name: string, selectedValue: string) => {
    console.log(`Selected value: ${selectedValue}`);
    setSelectedValue(selectedValue);
  };
  const addCommasToNumber = (value: any) => {
    if (value === null) {
      return ''; 
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return (
    <>
      <div className="mt-[43px] text-center leading-5">
        <p className="font-semibold">Record Payment Manually</p>
        <p>(Manually input the payment details) </p>
      </div>

      <form className="mt-[20px]" onSubmit={handleRecordPayment}>
        {error ? <div className="text-center p-2 bg-red-300 text-red-700 font-medium mb-4 ">{error}</div> : null}

        <label htmlFor="Amount Received" className="block font-sm text-[13px] text-black  ml-[2em] md:ml-[-0.5em]">
          Amount Received
        </label>
        <InputComponent
          type="text"
          pattern="[0-9]*"
          value={addCommasToNumber(amount)}
          handleChange={(e: { target: { value: React.SetStateAction<string> } }) => setAmount(e.target.value)}
          placeholder="Amount Received"
          className="xl:w-[434px] lg:w-[434px] md:w-[434px] w-[300px] ml-[1em] xl:ml-[-0.2em] lg:ml-[-0.2em] md:ml-[-0.2em] "
          label={''}
        />

        <div className="mt-[1em]">
          <label htmlFor="Payment Date" className="block font-sm text-[13px] text-black  ml-[2em] md:ml-[-0.5em]">
            Payment Date
          </label>
          <InputComponent
            type="text"
            value={date}
            handleChange={(e: { target: { value: React.SetStateAction<string> } }) => setDate(e.target.value)}
            placeholder="Payment Date"
            handleOnFocus={(e: { target: { type: string } }) => {
              e.target.type = 'date';
            }}
            handleOnBlur={(e: { target: { type: string } }) => {
              e.target.type = 'text';
            }}
            className="xl:w-[434px] lg:w-[434px] md:w-[434px] w-[300px] ml-[1em] xl:ml-[-0.2em] lg:ml-[-0.2em] md:ml-[-0.2em] "
            label={''}
          />
        </div>

        <div className="mt-[1em]">
          <label htmlFor="Payment Method" className="block font-sm text-[13px] text-black ml-[2em] md:ml-[-0.5em]">
            Payment Method
          </label>
          <DropdownComponent
            options={dropDownPaymentMethod}
            value={selectedValue}
            placeholder="Payment Method"
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            isSubmitted={isSubmitted}
            onChange={handleChange}
            dropdownClassName="xl:w-[434px] lg:w-[434px] md:w-[434px] w-[300px] ml-[1em] xl:ml-[-0.2em] lg:ml-[-0.2em] md:ml-[-0.2em] bg-white  rounded py-1 focus:ring-0 pointer-events"
            iconClassName="lg:mt-[-4px] lg:mr-[15px] "
          />
        </div>

        <div className="flex justify-center pt-[147px] pb-[60px]">
          <Button isLoading={isLoading} disabled={isLoading} variant="secondary" text="Record Payment" size="small" />
        </div>
      </form>
    </>
  );
};

export { ManualRecordPayment };
